import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'eq-wkspc-card',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule],
  templateUrl: './eq-wkspc-card.component.html',
  styleUrl: './eq-wkspc-card.component.scss',
})
export class EqWkspcCardComponent {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() class: string = '';
  @Input() headerClass: string = 'card-header'
}
